export const PROMOTION_TYPES = {
  buy_pay: 'Leve X e pague Y',
  discount: 'Desconto',
  fixed_price: 'Preço fixo',
  coupon: 'Cupom',
  shipping_discount: 'Desconto no frete',
  items_discount: 'Desconto no subtotal',
};
